// extracted by mini-css-extract-plugin
export default {"container":"q_JlcSbJ53aIOtY0O1pX"};